var map = {
	"./background-cost.png": 193,
	"./background-vp-negative.png": 194,
	"./background-vp-normal.png": 195,
	"./crisis.png": 196,
	"./equipment.png": 197,
	"./hero.png": 198,
	"./location.png": 199,
	"./oversized-super-hero.png": 200,
	"./oversized-super-villain.png": 201,
	"./starter.png": 202,
	"./super-hero.png": 203,
	"./super-power.png": 204,
	"./super-villain.png": 205,
	"./villain.png": 206,
	"./vp-variable.png": 207,
	"./weakness.png": 208
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 158;


//////////////////
// WEBPACK FOOTER
// ./resources/card-templates \.png$
// module id = 158
// module chunks = 0